<div class="right_page" id="right_page" *ngIf="currentReport != null">
    <div class="right_page_top">
      <div class="right_page_top_block">
        <div class="top_btn_top_row">
          <div class="top_btn_top_row_left">
            <div>
              <ul class="top_btn">
                <li class="btn"
                  *ngIf="(currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed' || currentReport.run_status_text === 'Execution Failed') && hasLiveStatus(currentReport.report_links)"
                  (click)="showContent('statistic')" [ngClass]="{'active': activeContent === 'statistic'}">STATISTIC
                </li>
                <li class="btn"
                  *ngIf="(currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed' || currentReport.run_status_text === 'Execution Failed') && hasLiveStatus(currentReport.report_links)"
                  (click)="showContent('stepexecution')"
                  [ngClass]="{'active': activeContent === 'stepexecution'}">STEPWISE
                </li>
                <li class="btn"
                  *ngIf="(currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed' || currentReport.run_status_text === 'Execution Failed') && hasVideoLink(currentReport.report_links)"
                  (click)="showContent('video')" [ngClass]="{'active': activeContent === 'video'}">VIDEO</li>
                <li class="btn"
                  *ngIf="displayedContent === 'video' && hasSecondVideo()"
                  (click)="switchVideoSession(1)" [ngClass]="{'active': activeVideoSession === 1}">WINDOW 1</li>
                <li class="btn"
                  *ngIf="displayedContent === 'video' && hasSecondVideo()"
                  (click)="switchVideoSession(2)" [ngClass]="{'active': activeVideoSession === 2}">WINDOW 2</li>
                <li class="btn largebtn"
                  *ngIf="isCurrentUserBusniessAnalyst && (currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed'|| currentReport.run_status_text === 'Execution Failed') && selectedBrowser != '' && selectedIteration != ''"
                  (click)="showContent('busniessreview')" [ngClass]="{'active': activeContent === 'busniessreview'}">BUSNIESS REVIEW</li>
              </ul>
            </div>
            <div class="top_btn_dropdown" *ngIf="isDropdownVisible">
              <div *ngIf="currentReport?.report_links?.links">
                <select name="browser" id="browser" (change)="onChangeBrowser($event)"  [(ngModel)]="selectedBrowser" [disabled]="isDropdownDisabled">
                  <ng-container *ngIf="currentReport.run_status_text !== 'EXECUTE_FRAMEWORK' || displayedContent != 'stepexecution'">
                    <option *ngFor="let browserKey of objectKeys(currentReport.report_links.links)"
                      [value]="browserKey">{{ browserKey }}
                    </option>
                  </ng-container>
                </select>
              </div>
              <div *ngIf="currentReport?.report_links?.links">
                <select name="iteration" id="iteration" (change)="onChangeIteration($event)"
                  [(ngModel)]="selectedIteration" *ngIf="iterationOptions.length > 1" [disabled]="isDropdownDisabled">
                  <ng-container *ngIf="currentReport.run_status_text !== 'EXECUTE_FRAMEWORK' || displayedContent !== 'stepexecution'">
                    <option *ngFor="let option of iterationOptions" [value]="option">{{ option }}</option>
                  </ng-container>
                </select>
              </div>
            </div>
          </div>
          <div class="top_btn_top_row_right">
            <mat-icon class="share-icon" *ngIf="displayedContent === 'video' && currentReport?.report_links?.links && video_url !== null" (click)="openShareUrlPopup()"  matTooltip="Share Video Url">share</mat-icon>
            <ng-container *ngIf="datasetAvailable">
              <a (click)="downloadFile()">dataset</a>
            </ng-container>
            <a *ngIf="currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed' || currentReport.run_status_text === 'Execution Failed'" (click)="downloadLog()">log</a>
            <ng-container *ngIf="fromCodeReview && isCurrentUserCodeReview()">
              <button class="changebtn" (click)="onChangeReport()" [featureActionState]="'CODE_REVIEW'">Change Report</button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="right_page_middle">
      <ul class="right_page_middle_main">
        <li class="right_page_middle_report"
          *ngIf="(currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed' || currentReport.run_status_text === 'Execution Failed') && displayedContent === 'statistic' && hasLiveStatus(currentReport.report_links)">
          <ze-html id="html_report" *ngIf="currentReport?.report_links?.live_status"
          [report]=currentReport (changetoStepwise)="onChangeToStepwise($event)"></ze-html>
        </li>
        <li class="right_page_middle_report"
          *ngIf="(currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed' || currentReport.run_status_text === 'Execution Failed') && displayedContent === 'stepexecution' && hasLiveStatus(currentReport.report_links)">
          <ze-stepwise id="stepexecution" *ngIf="stepwiseReport?.report_links?.live_status && selectedBrowser != '' && selectedIteration != '' && isBrowserIterationDataAvailable"
            [statusModel]=stepwiseReport.report_links.live_status[selectedBrowser][selectedIteration] [expandStep]="stepNumberOpened" [reportStatus]="stepwiseReport.run_status_text"
            [reportId]="stepwiseReport._id" [browser]="selectedBrowser" [iteration]="selectedIteration"
            [isDb2]="viewtype == 'ide'"></ze-stepwise>
          <div class="loader-container" *ngIf="selectedBrowser === '' || selectedIteration === '' || !stepwiseReport?.report_links?.live_status || (stepwiseReport?.report_links?.live_status && selectedBrowser != '' && selectedIteration != '' && !isBrowserIterationDataAvailable && !currentReportLoadFailed)">
            <div class="report-loader"></div>
          </div>
          <div *ngIf="currentReportLoadFailed" class="current_report_load_failed">
            <img src="../../../assets/images/error-cross.png" alt="Error" class="alert-image">
            <h3>Error in loading report. retry loading again...</h3>
            <mat-icon (click)="checkStepwiseDataAndUpdate()" matTooltip="Retry">refresh</mat-icon>
          </div>
        </li>
        <li class="right_page_middle_report"
          *ngIf="(currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed'|| currentReport.run_status_text === 'Execution Failed') && displayedContent === 'busniessreview' && selectedBrowser != '' && selectedIteration != ''">
          <ze-busniess-review [reportId]="currentReport._id"></ze-busniess-review>
        </li>
        <li class="right_page_middle_report" *ngIf="displayedContent === 'video' && currentReport?.report_links?.links">
          <div id="video-display" class="video-container-fullscreen">
            
            <!-- Primary Video (Video 1) -->
            <div class="video-session-wrapper" *ngIf="!hasSecondVideo() || activeVideoSession === 1">
              <ze-video id="video" *ngIf="video_url !== null"
                [filename]=video_url [videoContent]="true" [username]="currentUser"></ze-video>
              <div class="loader-container" *ngIf="video_url == null && !videoNotFound && !updatingVideoUrl">
                <div class="report-loader"></div>
              </div>
              <div class="went-wrong" *ngIf="videoNotFound">
                <img src="../../../assets/images/error-404.png" alt="Not Found" class="not-found-image">
                <h3>Oops, Video not found!</h3>
                <p>Please visit video section after sometime. If the issue persists, contact support.</p>
              </div>
              <div class="loader-container" *ngIf="updatingVideoUrl">
                <div class="report-loader"></div>
              </div>
            </div>

            <!-- Secondary Video (Video 2) -->
            <div class="video-session-wrapper" *ngIf="hasSecondVideo() && activeVideoSession === 2">
              <ze-video id="video2" *ngIf="video_url_2 !== null"
                [filename]=video_url_2 [videoContent]="true" [username]="currentUser"></ze-video>
              <div class="loader-container" *ngIf="video_url_2 == null && !videoNotFound2 && !updatingVideoUrl2">
                <div class="report-loader"></div>
              </div>
              <div class="went-wrong" *ngIf="videoNotFound2">
                <img src="../../../assets/images/error-404.png" alt="Not Found" class="not-found-image">
                <h3>Oops, Video 2 not found!</h3>
                <p>Please visit video section after sometime. If the issue persists, contact support.</p>
              </div>
              <div class="loader-container" *ngIf="updatingVideoUrl2">
                <div class="report-loader"></div>
              </div>
            </div>

          </div>
        </li>
        <li class="right_page_middle_report alert-container" *ngIf="(currentReport.run_status_text == 'Completed' || currentReport.run_status_text === 'Failed'|| currentReport.run_status_text === 'Execution Failed' )  && !hasLiveStatus(currentReport.report_links)">
          <div class="went-wrong">
            <img src="../../../assets/images/alert.png" alt="Alert" class="alert-image">
            <h3>Oops, Something went wrong!</h3>
            <p>Please try again with new execution. If the issue persists, contact support.</p>
          </div>
        </li>
      </ul>
    </div>
</div>



<div class="loader-container" *ngIf="currentReport == null && !reportNotFound">
  <div class="report-loader"></div>
</div>
<div class="container" *ngIf="reportNotFound">
    <div class="row">
        <div class="col-sm-12 center input-container-box">
            <img src="../../../assets/images/error-cross.png" alt="Error" class="error-image">
            <h3>Link Invalid or Report Not Available</h3>
        </div>
    </div>
</div>

<ze-share-text-modal></ze-share-text-modal>